export const Slideshow = () => import(/* webpackChunkName: "views/images/Slideshow" */ './Slideshow.vue')
export const SlideshowGallery = () => import(/* webpackChunkName: "views/images/SlideshowGallery" */ './SlideshowGallery.vue')
export const ModalImages = () => import(/* webpackChunkName: "views/images/ModalImages" */ './ModalImages.vue')
export const Lightbox = () => import(/* webpackChunkName: "views/images/Lightbox" */ './Lightbox.vue')
